var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stock-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('stock-card')],1),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('stock-rise')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e24109","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stockmarket.vue
// module id = null
// module chunks = 